import {
  GET_UNSUBSCRIBED_EMAILS,
  RESUBSCRIBE_EMAIL,
} from '../../state/actionTypes';
import EmailSubscriptionService from './emailSubscription.service';

export const getUnsubscribedEmails = () => async (dispatch) => {
  const { data } = await EmailSubscriptionService.getUnsubscribed();
  if (!data) return false;
  dispatch({
    type: GET_UNSUBSCRIBED_EMAILS,
    payload: {
      emails: data,
    },
  });
  return true;
};

export const resubscribeEmail = (id, password) => async (dispatch) => {
  const { data } = await EmailSubscriptionService.resubscribe(id, password);
  if (!data?.email) return false;
  dispatch({
    type: RESUBSCRIBE_EMAIL,
    payload: {
      email: data.email,
    },
  });
  return true;
};
